/// <reference path="../model-viewer/geometry.face.model.ts" />
/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../model-viewer/model.viewer.controller.ts" />

module Eseebase {
    export interface IModelMenuScope extends ng.IScope {
        openMenu: Function;
        updateScroll: Function;
        file: FileModel;
        getOrientation: Function;
        menuOpenerX: number;
        menuOpenerY: number;
        fileToken: string;
        blobToken: string;
        blobBaseUrl: string;
        canUpload: Function;
        canCreate: Function;
        isDeveloper: Function;
        isAngel: Function;
        isCaneaSyncEnabled: Function;
        onReuploadClick: Function;
        onReloadClick: Function;
        onDeleteClick: Function;
        isInProgress: Function;
        getIfcFileName: Function;
        onForgeJobSchedule: Function;
        hasFeature: Function;
        previewApartments: Function;
        previewOutdoor: Function;
        previewRoom: Function;
        downloadAreaCsv: Function;
        features: CompanyFeatureList;
        currentCompanyNumber: string;
    }

    export class ModelMenuDirective {
        public link: (scope: IModelMenuScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/model-menu.html';
        public scope = {
            onReuploadClick: '&',
            onRerunClick: '&',
            onForgeJobSchedule: '&',
            onDeleteClick: '&',
            onCreateClick: '&',
            onToggleInCaneaClick: '&'
        };
        public restrict = 'E';
        public require: string;
        public replace: any;

        constructor($timeout: ng.ITimeoutService,
                fileService: FileService,
                organizationSettingsService: OrganizationSettingsService,
                $mdDialog: any,
                userService: UserService,
                companyService: CompanyService,
                areaService: AreaService
        ) {
            var vm = this;
            ModelMenuDirective.prototype.replace = 'true';
            ModelMenuDirective.prototype.link = (scope: IModelMenuScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                element.closest('tbody').on('scroll', (evt) => {
                    if (evt != null && evt.target != null)
                    {
                        scope.updateScroll(angular.element(evt.target).parent());
                    }
                    
                });
                var user: UserModel;
                userService.getUser().then((data: UserModel) => user = data);
                organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => {
                    scope.features = features
                });
                scope.currentCompanyNumber = companyService.getCurrentCompanyNumber()

                scope.canUpload = () => {
                    return user != null && user.roles != null && user.roles.indexOf('Upload Model') > -1;
                }

                scope.canCreate = (file: FileModel) => {
                    return scope.canUpload() && file != null && (file.status == '' || file.status == FileStatus[FileStatus.New]);
                }

                scope.isDeveloper = () => {
                    return user != null && user.roles != null && user.roles.indexOf('Developer') > -1;
                }

                scope.isAngel = () => {
                    return user != null && user.roles != null && user.roles.indexOf('Angel') > -1;
                }

                scope.isCaneaSyncEnabled = () => {
                    var currentCompany = (user.companies as any).find(c => c.companyNumber == scope.currentCompanyNumber);
                    return currentCompany != null && currentCompany.caneaSyncEnabled;
                }

                scope.updateScroll = (target) => {
                    if (scope.file != null) {
                        $timeout(() => {
                            var tableOffset = angular.element(target).offset();
                            var $popup = element.find('.login-list-wrap');
                            var tBody = angular.element(target).find('tbody');
                            var table = angular.element(target);
                            var scrollTop = tBody.length > 0 ? tBody.scrollTop() : 0;
                            var scrollLeft = tBody.length > 0 ? tBody.scrollLeft() : 0;
                            var x = scope.menuOpenerX - (tableOffset != null ? tableOffset.left : 0) - 220 - scrollLeft;
                            var y = scope.menuOpenerY - (target[0].tagName.toLowerCase() == 'table' && tableOffset != null ? tableOffset.top : -270) - scrollTop - $popup.height();
                            if (target[0].tagName.toLowerCase() == 'table' && (y > table.height() - $popup.height() || y < -$popup.height() + 60)) {
                                scope.file = null;
                            }
                            else {
                                if (y < -160) {
                                    y = -160;
                                }
                                $popup.css('top', y + 'px');
                                $popup.css('left', x + 'px');
                            }
                        });
                    }
                };

                scope.$on('menu-open', (event, args: any) => {
                    var $event = args.$event;
                    var file = args.file;
                    if ($event != null && $event.target != null) {
                        $timeout(() => {
                            scope.file = file;
                            var tBody = element.closest('table').find('tbody');
                            var offset = angular.element($event.target).offset();
                            scope.menuOpenerX = offset.left + (tBody != null ? tBody.scrollLeft() : 0);
                            scope.menuOpenerY = offset.top + (tBody != null ? tBody.scrollTop() : 0);
                            if (element.closest('table').length > 0) {
                                scope.updateScroll(element.closest('table'));
                            }
                            else {
                                var targetElement = angular.element($event.target).closest('.modeller-table-area');
                                scope.updateScroll(targetElement);
                            }
                        });
                    }
                });

                scope.getIfcFileName = (file: FileModel) => {
                    return file.fileName.substring(0, file.fileName.length - 4) + 'ifc';
                }

                scope.isInProgress = (file: FileModel) => {
                    if (file == null) {
                        return false;
                    }
                    return file.status == FileStatus[FileStatus.Uploading] || file.status == FileStatus[FileStatus.Verifying] || file.status == FileStatus[FileStatus.Extracting];
                };

                scope.previewApartments = (f: FileModel, evt) => {
                    if (!f.hasApartmentsGeometry) {
                        return;
                    }
                    $mdDialog.show({
                        locals: { file: f, geometryType: 'apartments' },
                        controller: 'ModelViewerController',
                        controllerAs: 'vm',
                        templateUrl: '/app/dialog/model-viewer.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        targetEvent: evt
                    })
                    .then(() => {
                    }, () => { });
                }

                scope.previewOutdoor = (f: FileModel, evt) => {
                    if (!f.hasOutdoorGeometry) {
                        return;
                    }
                    $mdDialog.show({
                        locals: { file: f, geometryType: 'outdoor' },
                        controller: 'ModelViewerController',
                        controllerAs: 'vm',
                        templateUrl: '/app/dialog/model-viewer.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        targetEvent: evt
                    })
                        .then(() => {
                        }, () => { });
                }

                scope.previewRoom = (f: FileModel, evt) => {
                    if (!f.hasRoomGeometry) {
                        return;
                    }
                    $mdDialog.show({
                        locals: { file: f, geometryType: 'room' },
                        controller: 'ModelViewerController',
                        controllerAs: 'vm',
                        templateUrl: '/app/dialog/model-viewer.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        targetEvent: evt
                    })
                        .then(() => {
                        }, () => { });
                }

                scope.downloadAreaCsv = (f: FileModel) => {
                    areaService.getAreaCsv(f.id).then((data) => {
                        var name = 'area-' + f.localizer + '.csv';
                        if (data != null && navigator.msSaveBlob)
                            return navigator.msSaveBlob(new Blob([data], { type: 'text/csv' }), name);
                        var a = $("<a style='display: none;' target='_blank'/>");
                        var url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
                        a.attr("href", url);
                        a.attr("download", name);
                        $("body").append(a);
                        a[0].click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    }, () => {

                    });
                }

                angular.element('body').click(() => $timeout(() => {
                    scope.file = null;
                }));

                fileService.getFileToken().then((token: string) => scope.fileToken = token);
                fileService.getBlobToken().then((token: string) => scope.blobToken = token);
                fileService.getBlobBaseUrl().then((url: string) => scope.blobBaseUrl = url);
            }
        }

        public static Factory() {
            var directive = ($timeout: ng.ITimeoutService, fileService: FileService, organizationSettingsService: OrganizationSettingsService, $mdDialog: any, userService: UserService, companyService: CompanyService, areaService: AreaService) => {
                return new ModelMenuDirective($timeout, fileService, organizationSettingsService, $mdDialog, userService, companyService, areaService);
            };

            directive['$inject'] = ['$timeout', 'FileService', 'OrganizationSettingsService', '$mdDialog', 'UserService', 'CompanyService', 'AreaService'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('modelMenu', ModelMenuDirective.Factory());
}